function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import typography from '../utils/typography';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    active,
    disabled,
    dragging,
    error,
    filled,
    focused,
    hover,
    separateLabel
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => {
    var borderWidth = (active || focused) && !disabled ? '2px' : '1px';
    var isHc = theme.mode === 'contrast';
    var backgroundColor = 'transparent';
    var borderStyle = 'solid';
    var isHighDensity = theme.density === 'high';
    var separateLabelHeight = isHighDensity ? "calc(".concat(theme.layout.size8, " - ").concat(theme.layout.size1, ")") : "calc(".concat(theme.layout.size8, " + 2px)");
    var uploadButtonWidth = isHighDensity ? '46px' : '54px';
    var inputPadding = !filled ? {
      padding: theme.orbitalOne === 0 ? "calc(".concat(theme.orbitalFour, " - 2px) 0") : "calc(".concat(theme.orbitalOne, " + ").concat(theme.orbitalTwo, ") 0"),
      paddingLeft: "calc(".concat(theme.orbitalFour, ")"),
      paddingRight: "calc(".concat(theme.orbitalFour, ")")
    } : undefined;
    var borderColor = () => {
      if (disabled) return theme.palette.foreground.disabled;
      if (isHc) {
        if (error && focused) return theme.palette.neutral.active;
        if (focused) return theme.palette.neutral.active;
        if (active) return theme.palette.neutral.active;
        if (hover) return theme.palette.neutral.hover;
      }
      if (dragging) {
        backgroundColor = theme.palette.neutral.backgroundLight;
        borderStyle = 'dashed';
        return theme.palette.primary.default;
      }
      if (error) {
        if (focused) return theme.palette.primary.default;
        if (active) return theme.palette.negative.active;
        if (hover) return theme.palette.negative.hover;
        return theme.palette.negative.default;
      }
      if (focused) return theme.palette.primary.default;
      if (active) return theme.palette.neutral.active;
      if (hover) return theme.palette.neutral.hover;
      return theme.palette.neutral.default;
    };

    // upload button
    var fillColor = () => {
      if (disabled) return theme.palette.foreground.disabled;
      if (isHc && active) return theme.palette.neutral.active;
      if (isHc && focused) return theme.palette.neutral.active;
      if (focused) return theme.palette.foreground.inverse;
      if (active) return theme.palette.neutral.active;
      if (hover || dragging) return theme.palette.neutral.hover;
      return theme.palette.neutral.default;
    };
    return {
      root: {
        cursor: !disabled ? 'pointer' : 'default',
        zIndex: 1,
        '> div': _objectSpread(_objectSpread({}, dragging && {
          backgroundColor
        }), {}, {
          borderRadius: theme.borderRadius,
          pointerEvents: 'none'
        }),
        '> div > label + .vn-input input': {
          padding: 0
        },
        '> div > .vn-input': _objectSpread(_objectSpread(_objectSpread({}, !dragging && {
          backgroundColor
        }), {}, {
          borderColor: borderColor(),
          borderRadius: theme.borderRadius,
          borderWidth,
          borderRightWidth: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderStyle,
          display: 'flex',
          flex: 1
        }, inputPadding), {}, {
          '> input': {
            display: 'none',
            opacity: 0
          },
          '> label': {
            marginRight: filled ? theme.layout.size6 : undefined
          },
          '> .vn-input__file': _objectSpread(_objectSpread(_objectSpread({
            color: disabled ? theme.palette.foreground.disabled : theme.palette.foreground.default,
            cursor: !disabled ? 'pointer' : 'default'
          }, typography(theme).label), {}, {
            minWidth: '144px',
            overflow: 'hidden',
            padding: "calc(".concat(theme.orbitalThree, " - ").concat(borderWidth, ")")
          }, !separateLabel && {
            paddingBottom: theme.orbitalOne === 0 ? "calc(".concat(theme.layout.size1, " - ").concat(borderWidth, ")") : "calc(".concat(theme.orbitalOne, " - ").concat(borderWidth, ")"),
            paddingTop: "calc(".concat(theme.orbitalThree, " + ").concat(theme.orbitalTwo, " - ").concat(borderWidth, ")")
          }), {}, {
            pointerEvents: 'none',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%'
          })
        }, highContrastMediaQuery(theme)),
        '> div > .vn-input__icon': _objectSpread(_objectSpread({
          display: 'inline-flex',
          backgroundColor: 'transparent',
          border: "".concat(borderWidth, " solid ").concat(borderColor()),
          borderLeftColor: borderColor(),
          borderTopRightRadius: theme.borderRadius,
          borderBottomRightRadius: theme.borderRadius,
          padding: 0,
          transition: 'background-color 150ms ease-out, border-color 150ms linear'
        }, dragging && {
          marginLeft: 2
        }), !disabled && _objectSpread(_objectSpread(_objectSpread({}, (hover || dragging) && {
          backgroundColor: theme.palette.neutral.backgroundLight
        }), active && {
          backgroundColor: theme.palette.neutral.background
        }), focused && _objectSpread({
          backgroundColor: theme.palette.primary.default
        }, isHc && {
          backgroundColor: 'transparent'
        })))
      },
      container: {
        position: 'relative'
      },
      uploadButton: {
        cursor: !disabled ? 'pointer' : 'default',
        display: 'inline-flex',
        padding: theme.orbitalOne === 0 ? "calc(6px - ".concat(borderWidth, ") 0") : "calc(".concat(theme.orbitalOne, " + ").concat(theme.orbitalTwo, " - ").concat(borderWidth, ") 0"),
        paddingLeft: "calc(".concat(theme.orbitalFour, " - ").concat(borderWidth, ")"),
        paddingRight: "calc(".concat(theme.orbitalFour, " - ").concat(borderWidth, ")"),
        '> svg': {
          pointerEvents: 'none',
          fill: fillColor(),
          transition: 'fill 150ms linear'
        }
      },
      clearButton: {
        cursor: 'pointer',
        position: 'absolute',
        right: "calc(".concat(uploadButtonWidth, " + ").concat(theme.orbitalTwo, ")"),
        top: separateLabel ? separateLabelHeight : isHighDensity ? "calc(".concat(theme.layout.size1, " - 2px)") : theme.layout.size2,
        zIndex: 3
      }
    };
  }, [active, disabled, dragging, error, filled, focused, hover, separateLabel, theme]);
};
export default useStyles;